import {Resolver} from './types';

const resolveToCallable = (
    resolver: Resolver
): (x: any) => any => {
    if (typeof resolver === 'string') {
        return (x) => x[resolver];
    }

    if (resolver === null || typeof resolver === 'undefined') {
        return () => {};
    }

    return resolver;
};

export default resolveToCallable;
